import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";

interface CreationResult {
  requestId: string;
  journalNumber: string;
  status: "SUCCESS" | "FAIL";
  message?: string;
}

export interface JournalApprovalCreateItem {
  journalNumber: string;
  journalId?: string;
  journalTranId?: string;
  recordType?: string;
  recordTypeLabel?: string;
}

export const useCreateJournalApprovalRequests = () => {
  const [creationResults, setCreationResults] = useState<CreationResult[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { fetchWithReauth } = useAuth();

  const createJournalApprovalRequests = async (
    items: Array<string | JournalApprovalCreateItem>
  ) => {
    setLoading(true);
    try {
      const journalNumbers = items.map((item) =>
        typeof item === "string"
          ? item
          : {
              journalNumber: item.journalNumber,
              ...(item.journalId ? { journalId: item.journalId } : {}),
              ...(item.journalTranId
                ? { journalTranId: item.journalTranId }
                : {}),
              ...(item.recordType ? { recordType: item.recordType } : {}),
              ...(item.recordTypeLabel
                ? { recordTypeLabel: item.recordTypeLabel }
                : {}),
            }
      );
      const response = await fetchWithReauth(`${API_URL}/journal-approvals`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ journalNumbers }),
      });
      const data = await checkResponse(response);
      setCreationResults(data.results);
    } catch (error) {
      console.error("Error creating journal approval requests:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    creationResults,
    loading,
    createJournalApprovalRequests,
  };
};
